export default __webpack_public_path__ + "static/media/manually.e7b0f8e9.svg";